import { Controller } from '@hotwired/stimulus';

/**
 * Events component.
 */
export default class extends Controller {
    connect() {

        const header = document.querySelector('.header');
        const headerNav = document.querySelector('.header-navigation')

        if (header) {
            const btn = header.querySelector('.button:not(.btn-tertiary)');

            header.classList.add('stage-nav');

            if (btn) {
                btn.classList.remove('btn-primary');
                btn.classList.add('btn-primary-inverted');
            }

            const handleHover = () => {
                header.classList.add('hovered');
                if (btn) {
                    btn.classList.add('btn-primary');
                    btn.classList.remove('btn-primary-inverted');
                }
            };

            const handleLeave = () => {
                header.classList.remove('hovered');
                if (btn && !header.classList.contains('nav-down-active')) {
                    btn.classList.remove('btn-primary');
                    btn.classList.add('btn-primary-inverted');
                }
            };

            const handleClick = () => {

                if (headerNav.classList.contains('show')) {
                    header.classList.add('clicked');
                    btn.classList.add('btn-primary');
                    btn.classList.remove('btn-primary-inverted');
                } else {
                    header.classList.remove('clicked');
                    btn.classList.remove('btn-primary');
                    btn.classList.add('btn-primary-inverted');
                }
            };


            const isWideScreen = () => window.innerWidth > 1350;

            const attachListeners = () => {
                header.removeEventListener('mouseenter', handleHover);
                header.removeEventListener('mouseleave', handleLeave);
                header.removeEventListener('click', handleClick);

                if (isWideScreen()) {
                    header.addEventListener('mouseenter', handleHover);
                    header.addEventListener('mouseleave', handleLeave);
                } else {
                    header.addEventListener('click', handleClick);
                }
            };

            attachListeners();

            window.addEventListener('resize', attachListeners);
        }



    }
}